module.exports = ".settings-section-header-title {\n  color: #4e5e6a; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/settings/common/setting-section-header/setting-section-header.scss
// module id = ./web/modern/components/settings/common/setting-section-header/setting-section-header.scss
// module chunks = 0